import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Ship} from '../../../Ship';
import {ShipRoundTripHistory} from '../../../data/ShipRoundTripHistory';
import {EntitlementService} from '../../../services/entitlement.service';
import {ShipReportService} from '../../../services/ship-report.service';
import {Router} from '@angular/router';
import {EomReportDetails} from '../../../data/EomReportDetails';
import {ShipInstallation} from '../../../data/ShipInstallation';

@Component({
  selector: 'app-round-trip-overview',
  templateUrl: './round-trip-overview.component.html',
  styleUrls: ['./round-trip-overview.component.css']
})
export class RoundTripOverviewComponent implements OnInit {
  @Input() ship: Ship;
  @Input() shipRoundTripHistory: ShipRoundTripHistory;
  @Input() shipInstallations: ShipInstallation[];
  @Input() lastEOMDetails: EomReportDetails[];

  constructor(private entitlementService: EntitlementService, private shipReportService: ShipReportService, private router: Router) { }

  ngOnInit() {
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  updateShipData(newShip: Ship, newShipRoundTripHistory: ShipRoundTripHistory, shipInstallations: ShipInstallation[]) {
    this.ship = newShip;
    this.shipRoundTripHistory = newShipRoundTripHistory;
    this.shipInstallations = shipInstallations;
  }

  gotoShipReports(lastRoundtripDetailBatchId: string) {
    const test = {
      location: this.ship.shipLocation,
      batch: lastRoundtripDetailBatchId,
      reportName: 'NC2_EOM_VOUCHER_SUMMARY_REPORT_M'
    };
    this.shipReportService.storeReport(test);
    this.router.navigate(['/reports/shipReports']);
  }
}
